// 현장 연결 코드 액션(rpc) — 직원 발급·재발급 · 고객이 코드+전화 끝 4자리로 연결(로그인 없음).
import { rpc } from "@/api/client";

export const issueProjectConnectCode = (projectId: string) => rpc("project/connect-actions/issueProjectConnectCode", { project_id: projectId });

export const connectProjectByCode = (input: { code: string; last4: string }) => rpc("project/connect-actions/connectProjectByCode", input);
